<template>
	<div class="asked u-flex-col u-col-center">
		<div class="asked-box u-flex-col u-col-center u-row-center">
      <div class="title fadeInUp animated">{{$t('常见问题')}}</div>
      <el-collapse v-model="activeName" accordion @change="getda">
        <el-collapse-item :name="index + 1" v-for="(item,index) in list" :key="index">
          <template slot="title">
            <div class="fadeInUp animated" v-if="$locale == 'en'">{{ item.problemNameEnglish }}</div>
            <div class="fadeInUp animated" v-if="$locale == 'zh'">{{ item.problemName }}</div>
          </template>
          <div v-if="$locale == 'en'" v-html="data.problemAnswerEnglish"></div>
          <div v-if="$locale == 'zh'" v-html="data.problemAnswer"></div>
        </el-collapse-item>
      </el-collapse>
    </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
        data: {},
				activeName: '1'
			}
		},
		created() {
			this.getlist()
		},
		mounted() {
			this.$parent.settitle(this.$t('常见问题'))
		},
		methods: {
			getlist() {
        this.$http.get('/api/Index/getAllCommonProblem').then((res) => {
          this.list = res.result
        })
      },
      getda(e) {
        this.data = {}
        if(e > 0) {
          this.$http.get('/api/Index/getProblemAnswer/' + this.list[e - 1].id).then((res) => {
            this.data = res.result
          })
        }
      },
		}
	}
</script>

<style lang="scss">
  .el-collapse {
    width: 100%;
    background: rgba($color: #000000, $alpha: 0);
    border-bottom: 1px solid rgba($color: #fff, $alpha: 0.3);
    border-top: none;
    .el-collapse-item__header {
      background: rgba($color: #000000, $alpha: 0);
      color: #fff;
      padding: 36px 0;
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0.3);
      height: unset;
      line-height: unset;
      font-size: 22px;
    }
    .el-collapse-item__wrap {
      // padding-top: 26px;
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0.3);
      background: rgba($color: #000000, $alpha: 0);
      .el-collapse-item__content {
        color: #fff;
        font-size: 16px;
        p {
          background: rgba($color: #000000, $alpha: 0) !important;
          color: #fff !important;
        }
        span {
          background: rgba($color: #000000, $alpha: 0) !important;
          color: #fff !important;
        }
      }
    }
  }
  .fadeInUp {
		-webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
		visibility: visible;
	}
	.animated {
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
	}
	@keyframes fadeInUp {
		0% {
			opacity: 0;
			-webkit-transform: translate3d(0,100%,0);
			transform: translate3d(0,100%,0);
		}
		100% {
			opacity: 1;
			-webkit-transform: none;
			transform: none;
		}
	}
</style>